// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__bBUEX","content":"RecentSearches_content__1W8Zc"};